module.exports = __webpack_public_path__ + "assets/mastercard-043028.svg";